import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { deviationSchema } from '../normalizr/schemas/deviation';
import set from 'lodash/set';
import { userSchema } from '../normalizr/schemas/user';
import { galleryFolderSchema, collectionFolderSchema } from '../normalizr/schemas/folder';
// we want to preserve expandables if the incoming entity was not expanded
// otherwise, overwrite everything
function preserveExisting(existing, incoming) {
    if (existing !== undefined && incoming === undefined) {
        return existing;
    }
    return incoming;
}
function mergeTextContent(existing, incoming) {
    if (!existing || !incoming) {
        return incoming;
    }
    // if the existing is expanded, and the incoming is not, keep the existing
    // do not attempt to merge to avoid tearing between excerpt and markup
    if (existing.html.markup !== undefined && incoming.html.markup === undefined) {
        return existing;
    }
    return incoming;
}
function dropUndefined(thing) {
    const copy = {};
    Object.keys(thing).forEach((key)=>{
        if (thing[key] !== undefined) {
            copy[key] = thing[key];
        }
    });
    return copy;
}
function mergeDeviationEntity(existing, incoming) {
    const merged = _object_spread_props(_object_spread({}, incoming), {
        textContent: mergeTextContent(existing.textContent, incoming.textContent),
        dailyDeviation: preserveExisting(existing.dailyDeviation, incoming.dailyDeviation),
        pcp: preserveExisting(existing.pcp, incoming.pcp),
        background: preserveExisting(existing.background, incoming.background),
        extended: preserveExisting(existing.extended, incoming.extended),
        suggestedReasons: preserveExisting(existing.suggestedReasons, incoming.suggestedReasons)
    });
    return dropUndefined(merged);
}
// groups are stupid and we need to fully merge the extended data
function mergedExtendedGroup(existing, incoming) {
    if (!existing || !incoming) {
        return incoming !== null && incoming !== void 0 ? incoming : existing;
    }
    const existingApps = existing.apps;
    const incomingApps = incoming.apps;
    if (!existingApps || !incomingApps) {
        return _object_spread_props(_object_spread({}, existing, incoming), {
            apps: incomingApps !== null && incomingApps !== void 0 ? incomingApps : existingApps
        });
    }
    var _incomingApps_gallery, _incomingApps_posts, _incomingApps_join;
    const merged = _object_spread_props(_object_spread({}, existing, incoming), {
        apps: dropUndefined(_object_spread_props(_object_spread({}, incomingApps), {
            gallery: (_incomingApps_gallery = incomingApps.gallery) !== null && _incomingApps_gallery !== void 0 ? _incomingApps_gallery : existingApps.gallery,
            posts: (_incomingApps_posts = incomingApps.posts) !== null && _incomingApps_posts !== void 0 ? _incomingApps_posts : existingApps.posts,
            join: (_incomingApps_join = incomingApps.join) !== null && _incomingApps_join !== void 0 ? _incomingApps_join : existingApps.join
        }))
    });
    return dropUndefined(merged);
}
function mergeUserEntity(existing, incoming) {
    var _existing_extendedGroup_apps_posts, _existing_extendedGroup_apps, _existing_extendedGroup, _merged_extendedGroup_apps_posts, _merged_extendedGroup_apps, _merged_extendedGroup;
    // we need to preserve this one especially because it might be absent even
    // when all other things in the expand are present
    const latestPostTs = (_existing_extendedGroup = existing.extendedGroup) === null || _existing_extendedGroup === void 0 ? void 0 : (_existing_extendedGroup_apps = _existing_extendedGroup.apps) === null || _existing_extendedGroup_apps === void 0 ? void 0 : (_existing_extendedGroup_apps_posts = _existing_extendedGroup_apps.posts) === null || _existing_extendedGroup_apps_posts === void 0 ? void 0 : _existing_extendedGroup_apps_posts.latestPostTs;
    const merged = _object_spread_props(_object_spread({}, incoming), {
        details: preserveExisting(existing.details, incoming.details),
        geo: preserveExisting(existing.geo, incoming.geo),
        profile: preserveExisting(existing.profile, incoming.profile),
        stats: preserveExisting(existing.stats, incoming.stats),
        isWatching: preserveExisting(existing.isWatching, incoming.isWatching),
        isBirthweek: preserveExisting(existing.isBirthweek, incoming.isBirthweek),
        networkbar: preserveExisting(existing.networkbar, incoming.networkbar),
        extendedGroup: mergedExtendedGroup(existing.extendedGroup, incoming.extendedGroup)
    });
    if (latestPostTs && !((_merged_extendedGroup = merged.extendedGroup) === null || _merged_extendedGroup === void 0 ? void 0 : (_merged_extendedGroup_apps = _merged_extendedGroup.apps) === null || _merged_extendedGroup_apps === void 0 ? void 0 : (_merged_extendedGroup_apps_posts = _merged_extendedGroup_apps.posts) === null || _merged_extendedGroup_apps_posts === void 0 ? void 0 : _merged_extendedGroup_apps_posts.latestPostTs)) {
        set(merged, 'extendedGroup.apps.posts.latestPostTs', latestPostTs);
    }
    return dropUndefined(merged);
}
function mergeGallectionEntity(existing, incoming) {
    const merged = _object_spread_props(_object_spread({}, incoming), {
        totalItemCount: preserveExisting(existing.totalItemCount, incoming.totalItemCount),
        hasSubfolders: preserveExisting(existing.hasSubfolders, incoming.hasSubfolders),
        subfolders: preserveExisting(existing.subfolders, incoming.subfolders)
    });
    return dropUndefined(merged);
}
export const entityMergers = {
    [deviationSchema.key]: mergeDeviationEntity,
    [userSchema.key]: mergeUserEntity,
    [galleryFolderSchema.key]: mergeGallectionEntity,
    [collectionFolderSchema.key]: mergeGallectionEntity
};
